import { render, staticRenderFns } from "./password-tip.vue?vue&type=template&id=5ed91ac4&"
import script from "@/model/passwordtip?vue&type=script&lang=js&"
export * from "@/model/passwordtip?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports